import { render } from "./JobShifts.vue?vue&type=template&id=f7b6311a&ts=true"
import script from "./JobShifts.vue?vue&type=script&lang=ts"
export * from "./JobShifts.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__